module.exports = __webpack_public_path__ + "static/media/Мустафина И.Ж..08b8d8b8.pdf";